import React from "react";
import PropTypes from "prop-types";

import FormInput from "Common/Custom/FormInput";
import FormSelect from "Common/Custom/FormSelect";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";
import FormDatePicker from "Common/Custom/ReactFlatpickr";

const RoomCheckInForm = ({
   fields = [],
   values = {},
   errors = {},
   handleChange = () => { },
   handleSubmit = () => { },
   title = "Room Status",
   FloorListOptions = [],
}) => {
   return (
      <PageBody
         onSubmit={handleSubmit}
         headerchildren={<HeadingOne>{title}</HeadingOne>}
      >
         {fields.map((field) => {
            /* ---------- SELECT ---------- */
            if (field.type === "select") {
               let FloorOptions = [];

               if (field.name === "floor") {
                  FloorOptions = FloorListOptions.map((opt) => ({
                     label: opt.floor_name,
                     value: opt.floor_name,
                  }));
               }

               return (
                  <FormSelect
                     key={field.name}
                     field={field}
                     value={values[field.name]}
                     handleChange={handleChange}
                     options={
                        field.name === "floor" ? FloorOptions : field.options
                     }
                     error={errors[field.name]}
                  />
               );
            }

            /* ---------- DATE ---------- */
            if (field.type === "date") {
               return (
                  <FormDatePicker
                     key={field.name}
                     field={field}
                     value={values[field.name]}
                     handleChange={handleChange}
                     error={errors[field.name]}
                     mode="date"
                  />
               );
            }

            /* ---------- DEFAULT INPUT ---------- */
            return (
               <FormInput
                  key={field.name}
                  field={field}
                  value={values[field.name]}
                  handleChange={handleChange}
                  error={errors[field.name]}
               />
            );
         })}
      </PageBody>
   );
};

/* =====================
   PROP TYPES
   ===================== */
RoomCheckInForm.propTypes = {
   title: PropTypes.string,

   fields: PropTypes.arrayOf(
      PropTypes.shape({
         name: PropTypes.string.isRequired,
         label: PropTypes.string,
         type: PropTypes.oneOf(["text", "select", "date", "number", "email"]),
         options: PropTypes.arrayOf(
            PropTypes.shape({
               label: PropTypes.string,
               value: PropTypes.any,
            })
         ),
      })
   ),

   values: PropTypes.object,
   errors: PropTypes.object,
   handleChange: PropTypes.func,
   handleSubmit: PropTypes.func,

   FloorListOptions: PropTypes.arrayOf(
      PropTypes.shape({
         floor_name: PropTypes.string.isRequired,
      })
   ),
};

export default RoomCheckInForm;
